import React, { useState, useEffect } from "react";
import { Form, Radio } from "antd";

const FormItemRadio = ({ data, error, onInputChange }) => {
    const { name, label, value, options, required } = data;

    const [formData, setFormData] = useState({
        [name]: value
    });

    const [formErrors, setFormErrors] = useState({
        [name]: error
    });

    useEffect(() => {
        if (value) {
            setFormData({ [name]: value });
        } else {
            setFormData({ [name]: "" });
        }
    }, [value]);

    useEffect(() => {
        setFormErrors({ [name]: error });
    }, [error]);

    const handleInputChange = (name, value) => {
        let errors = { ...formErrors };
        if (value.trim() !== "") {
            errors[name] = "";
            setFormErrors(errors);
        }

        setFormData({
            ...formData,
            [name]: value
        });
        onInputChange(name, value);
    };

    return (
        <Form.Item
            label={label}
            required={required}
            validateStatus={formErrors[name] && "error"}
            help={formErrors[name] && formErrors[name]}
        >
            <Radio.Group
                defaultValue={value}
                value={formData[name]}
                onChange={e => handleInputChange(name, e.target.value)}
            >
                {options.map(radio => {
                    const { label, value } = radio;
                    return (
                        <Radio value={value} key={value}>
                            {label}
                        </Radio>
                    );
                })}
            </Radio.Group>
        </Form.Item>
    );
};

export default FormItemRadio;
